import React from 'react';
import iconSrc from '@/assets/arr_gpt_icon.png';
import '@/components/brand/arrangelly-brand.css';

export type ArrangellyBrandSize = 'sm' | 'md' | 'lg';

export interface ArrangellyBrandProps {
  size?: ArrangellyBrandSize;
  layout?: 'horizontal' | 'stacked';
  showSlogan?: boolean;
  /** Use on dark backgrounds (login, hero) */
  variant?: 'default' | 'on-dark';
  className?: string;
}

const iconPx: Record<ArrangellyBrandSize, number> = {
  sm: 28,
  md: 36,
  lg: 44,
};

const ArrangellyBrand: React.FC<ArrangellyBrandProps> = ({
  size = 'md',
  layout = 'horizontal',
  showSlogan = true,
  variant = 'default',
  className = '',
}) => {
  const px = iconPx[size];
  const rootClass = [
    'arrangelly-brand',
    `arrangelly-brand--${size}`,
    layout === 'stacked' ? 'arrangelly-brand--stacked' : 'arrangelly-brand--horizontal',
    variant === 'on-dark' ? 'arrangelly-brand--on-dark' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <img
        src={iconSrc}
        alt=""
        className="arrangelly-brand-icon"
        width={px}
        height={px}
        decoding="async"
        aria-hidden
      />
      <div className="arrangelly-brand-text">
        <span className="arrangelly-wordmark-title">arrangelly</span>
        {showSlogan && (
          <span className="arrangelly-wordmark-slogan">TEACH LIKE A PROFESSIONAL</span>
        )}
      </div>
    </div>
  );
};

export default ArrangellyBrand;
